import React, { useState } from "react";
import { Table, Select, Input } from "antd";
import styles from "./AdminAllerganManagement.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
const { Option } = Select;

const AdminAllerganManagement = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [isFilterModal, setIsFilterModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [role, setRole] = useState({
    value: "Admin",
    role: "admin",
    id: 1,
  });
  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Allergen Name",
      dataIndex: "AllergenName",
      key: "Allergen Name",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Linked Recipes",
      dataIndex: "LinkedRecipes",
      key: "department",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Linked Ingredients",
      dataIndex: "LinkedIngredients",
      key: "Linked Ingredients",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Last Modified",
      dataIndex: "LastModified",
      key: "Last Modified",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/AdminProductManagement/AllergenDetails")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/AdminProductManagement/EditAllergen")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      AllergenName: "Peanuts",
      Type: "System",
      LinkedRecipes: 1,
      LinkedIngredients: 1,
      LastModified: "Aug 01, 2025",
      action: "View",
    },
    {
      No: "2",
      AllergenName: "Dairy",
      LinkedRecipes: 2,
      LinkedIngredients: 5,
      LastModified: "Aug 01, 2025",

      Type: "System",
      action: "Edit",
    },
    {
      No: "  3   ",
      AllergenName: "Margarine",
      LinkedIngredients: 4,
      LastModified: "Aug 01, 2025",

      Type: "Custom",
      LinkedRecipes: 3,

      action: "View",
    },
    {
      No: "4",
      AllergenName: "Dairy",
      LinkedRecipes: 5,
      LinkedIngredients: 9,
      LastModified: "Aug 01, 2025",

      Type: "Custom",

      action: "View",
    },
    {
      No: "5",
      AllergenName: "Peanuts",
      LinkedRecipes: 4,
      LinkedIngredients: 3,
      LastModified: "Aug 01, 2025",
      action: "Deactivate",
      Type: "Custom",
    },
    {
      No: "6",
      AllergenName: "Margarine",
      Type: "Custom",
      LinkedRecipes: 2,
      LinkedIngredients: 8,
      LastModified: "Aug 01, 2025",

      action: "View",
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Allergen Management"}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/AdminProductManagement/AddAllergen")}
        submitButtonText={" Add Allergan"}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="staffId"
        />
      </div>

      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Role"}
          labelClass={styles.labelClass}
          value={role}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Supervisor",
              role: "supervisor",
              id: 1,
            },
            {
              value: "Staff Member",
              role: "staff",
              id: 2,
            },
          ]}
          onChange={(e) => setRole(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Media Type"}
          labelClass={styles.labelClass}
          value={role}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Video",
              role: "Video",
              id: 1,
            },
            {
              value: "PDF",
              role: "PDF",
              id: 2,
            },
          ]}
          onChange={(e) => setRole(e)}
        />
      </Modal>

      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>
    </div>
  );
};

export default AdminAllerganManagement;
